import BarChart4 from "@/components/BarChart4";
import CustomSlider from "@/components/CustomSlider";
import { SvgLock, SvgUnlock } from "@/utils/svgs";
import React from "react";
import { Slider } from "@/components/FileInput";

const metricClassName =
  "text-xs bg-white whitespace-nowrap text-gray-700 font-semibold py-2 px-2 border-gray-400 rounded-lg shadow-lg shadow-slate-300";

const CrossAsset = ({
  assetArray,
  firstAssetName,
  secondAssetName,
  alloc,
  handleInsuranceSliderValue,
  handleAllocSliderChange,
  handleAllocCommit,
  handleLock,
  lock,
  insuranceSliderValue,
  showInsuranceSlider,
}) => {
  return (
    <div className="grid grid-cols-12 gap-2 sm:gap-5">
      <div className="col-span-12 sm:col-span-7">
        <div className="flex flex-col mx-auto w-full bg-white rounded-lg shadow-xl shadow-slate-300 p-5">
          <BarChart4
            min={assetArray.min}
            max={assetArray.max}
            average={assetArray.average}
          />
        </div>
      </div>
      <div className="col-span-12 sm:col-span-5">
        <div className="flex w-full items-center gap-x-2">
          {showInsuranceSlider ? (
            <CustomSlider
              disabled={lock}
              min={0}
              max={100}
              sliderValue={insuranceSliderValue}
              displayValue={alloc["secondAssetAlloc"]}
              step={insuranceSliderValue <= 60 ? 0.1 : 1}
              onChange={handleInsuranceSliderValue}
              onMouseUp={handleAllocCommit}
              onTouchEnd={handleAllocCommit}
              data-testid="main-cross-asset-insurance-alloc-input:range" />
          ) : (
            <Slider
              disabled={lock}
              min={0}
              max={100}
              onChange={handleAllocSliderChange}
              onMouseUp={handleAllocCommit}
              onTouchEnd={handleAllocCommit}
              disabledBin={false}
              value={alloc["secondAssetAlloc"]}
              data-testid="main-cross-asset-alloc-input:range" />
          )}
          <button
            className="bg-[#e9e9ed] h-8 w-8 rounded-md border flex items-center justify-center"
            onClick={handleLock}
            aria-pressed={Boolean(lock)}
            aria-label="Lock allocation"
            data-testid="main-cross-asset-alloc-lock-toggle-btn">
            {lock ? (
              <SvgLock height={20} width={20} />
            ) : (
              <SvgUnlock height={20} width={20} />
            )}
          </button>
        </div>

        <div className="flex justify-center items-center gap-5 w-full max-w-2xl mt-2 mb-5 mx-auto relative">
          {alloc["firstAssetAlloc"] + "%"} {firstAssetName} +{" "}
          {alloc["secondAssetAlloc"] + "%"} {secondAssetName}
        </div>
        <div className="space-y-2 w-full md:w-max">
          <div className="flex justify-center md:justify-start gap-2">
            <span className={metricClassName}>
              {`AM: ${parseFloat(assetArray.am).toFixed(1)}%`}
            </span>
            <span className={metricClassName}>
              {`GM: ${parseFloat(assetArray.gm).toFixed(1)}%`}
            </span>
          </div>
          <div className="text-xs text-center md:text-left">Difference vs {firstAssetName}</div>
          <div className="flex justify-center md:justify-start gap-2">
            <span className={metricClassName}>
              {`AM: ${parseFloat(assetArray.diffAM).toFixed(1)}%`}
            </span>
            <span className={metricClassName}>
              {`GM: ${parseFloat(assetArray.diffGM).toFixed(1)}%`}
            </span>
          </div>
          <div className="flex justify-center md:justify-start gap-10 text-xs whitespace-nowrap text-gray-700 font-semibold">
            <p className="px-2">COST</p>
            <p className="px-2">NET</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrossAsset;
